/* global SideDrawer */

/**
 * Fix search result counts + pagination after Shopify renders.
 * Shopify includes discontinued products in counts/pagination but Liquid
 * skips them, so the numbers are inflated. This corrects them client-side.
 */
window.fixSearchCounts = function() {
  var container = document.querySelector('.search-content') || document.querySelector('.collection-content');
  if (!container) return;

  /* On collection pages, child-metafield-filters.js manages counts/pagination itself.
     Skip this function so we don't fight with it or show stale numbers. */
  var isCollectionPage = !!document.querySelector('.collection-content');
  if (isCollectionPage) {
    /* Still hide inflated filter option counts on collection pages */
    var filterCounts = document.querySelectorAll('.filter__count');
    for (var i = 0; i < filterCounts.length; i++) {
      filterCounts[i].style.display = 'none';
    }
    return;
  }

  /* ---- Search page logic below ---- */

  /* Count only visible (not display:none) product cards in the results grid */
  var filterResults = container.querySelector('#filter-results') || document.getElementById('filter-results');
  if (!filterResults) return;

  var allProducts = filterResults.querySelectorAll('.grid-product');
  var visibleCount = 0;
  for (var i = 0; i < allProducts.length; i++) {
    if (allProducts[i].offsetParent !== null) {
      visibleCount++;
    }
  }
  /* Fallback: if none are "visible" by offsetParent (e.g. page just loaded), count all */
  if (visibleCount === 0 && allProducts.length > 0) {
    visibleCount = allProducts.length;
  }

  /* Fix "X Results" in filter bar */
  var countEl = container.querySelector('.collection-filter__item--count');
  if (countEl) {
    countEl.textContent = visibleCount + (visibleCount === 1 ? ' Result' : ' Results');
  }

  /* Fix "Show X Results" footer button */
  var footerBtn = document.querySelector('.facets__footer-btn');
  if (footerBtn) {
    footerBtn.textContent = 'Show ' + visibleCount + (visibleCount === 1 ? ' Result' : ' Results');
  }

  /* Fix pagination counter */
  var counterText = container.querySelector('.pagination-counter__text') || document.querySelector('.pagination-counter__text');
  if (counterText) {
    counterText.innerHTML = 'Showing <strong>' + visibleCount + '</strong> products';
  }
  var counterTrack = container.querySelector('.pagination-counter__track') || document.querySelector('.pagination-counter__track');
  if (counterTrack) counterTrack.style.display = 'none';

  /* Hide pagination when visible products < per_page on page 1 */
  var pagination = container.querySelector('.pagination') || document.querySelector('#filter-results .pagination');
  if (pagination) {
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('page') || '1', 10);
    var urlPP = parseInt(params.get('per_page') || '', 10);
    var perPage = 60;
    if (urlPP === 20) perPage = 20;
    else if (urlPP === 40) perPage = 40;

    if (page === 1 && visibleCount < perPage) {
      pagination.style.display = 'none';
    } else {
      pagination.style.display = '';
    }
  }

  /* Hide filter option counts like "(499)" — inflated by discontinued */
  var filterCounts = document.querySelectorAll('.filter__count');
  for (var k = 0; k < filterCounts.length; k++) {
    filterCounts[k].style.display = 'none';
  }
};

// Minimal details-disclosure custom element (for selector compatibility)
if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', class extends HTMLElement {});
}

if (!customElements.get('facet-filters')) {
  class FacetFilters extends SideDrawer {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);
      if (this._mqListener) {
        this._mq.removeEventListener('change', this._mqListener);
      }
    }

    init() {
      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.form = document.getElementById('facets');
      this.results = document.getElementById('filter-results');
      this.expanded = [];
      this.filterChangeTimeout = null;

      // Media query for desktop breakpoint (MyBinding uses 769px)
      this._mq = window.matchMedia('(min-width: 769px)');

      this.handleBreakpointChange();
      this.addElements();
      this.addListeners();

      this.historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener('popstate', this.historyChangeHandler);
    }

    addElements() {
      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        this.activeFilters = this.querySelector('.facets__active-filters');
        this.activeFiltersList = this.querySelector('.active-filters');
        this.activeFiltersHeader = this.querySelector('.active-filters-header');
        this.footer = this.querySelector('.facets__footer');
      }

      if (this.sortingEnabled) {
        this.desktopSortBy = document.querySelector('#SortBy');
      }
    }

    addListeners() {
      if (this.filteringEnabled) {
        this._mqListener = this._mqListener || this.handleBreakpointChange.bind(this);
        this._mq.addEventListener('change', this._mqListener);
        this.filters.addEventListener('click', this.handleFiltersClick.bind(this));
        this.filters.addEventListener('input', this.handleFilterChange.bind(this));
        this.filters.addEventListener('change', this.handleFilterChange.bind(this));
        if (this.activeFilters) {
          this.activeFilters.addEventListener('click', this.handleActiveFiltersClick.bind(this));
        }
      }

      // Sort: bind once on results container via delegation (survives innerHTML replacement)
      if (this.sortingEnabled && this.results && !this._sortBound) {
        this.results.addEventListener('change', (evt) => {
          if (evt.target.id === 'SortBy') this.handleSortChange(evt);
        });
        this._sortBound = true;
      }
    }

    handleBreakpointChange() {
      if (this._mq.matches) {
        // Switching to desktop — ensure drawer/overlay are cleaned up
        if (this.overlay) this.overlay.classList.remove('is-visible');
        this.removeEventListener('click', this.clickHandler);
        this.removeEventListener('keyup', this.keyupHandler);
        if (this.overlay) this.overlay.removeEventListener('click', this.clickHandler);
        removeTrapFocus();

        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
      } else {
        // Switching to mobile — close drawer
        this.removeAttribute('open');
        if (this.overlay) this.overlay.classList.remove('is-visible');
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('aria-hidden', 'true');
        this.hidden = false;
      }
    }

    handleSortChange(evt) {
      const sortBy = evt.target.value;
      if (!sortBy) return;

      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);

      // Preserve cf_* params from URL
      const currentParams = new URLSearchParams(window.location.search);
      for (const [k, v] of currentParams.entries()) {
        if (k.startsWith('cf_') && v) searchParams.set(k, v);
      }

      // Preserve per_page
      const perPage = currentParams.get('per_page');
      if (perPage) searchParams.set('per_page', perPage);

      searchParams.set('sort_by', sortBy);
      searchParams.delete('page');

      // Remove empty params
      const emptyParams = [];
      searchParams.forEach((value, key) => { if (!value) emptyParams.push(key); });
      emptyParams.forEach((key) => searchParams.delete(key));

      this.applyFilters(searchParams.toString(), evt);
    }

    handleFilterChange(evt) {
      // Ignore child-metafield filter checkboxes (handled by custom-child-metafield-filters.js)
      if (evt.target.classList && evt.target.classList.contains('child-metafield-filters__input')) return;

      // Only allow price 'change' events
      if (evt.type === 'change' && !(evt.target.id?.includes('price-range') || evt.target.id?.includes('sort-by'))) return;

      // Don't reload when typing a price
      if (evt.target.id?.includes('price-range') && evt.constructor.name === 'InputEvent') return;

      const timeoutDelay = 500;
      clearTimeout(this.filterChangeTimeout);

      this.filterChangeTimeout = setTimeout(() => {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);
        const emptyParams = [];

        // Preserve cf_* params from current URL
        const currentParams = new URLSearchParams(window.location.search);
        for (const [k, v] of currentParams.entries()) {
          if (k.startsWith('cf_') && v) searchParams.set(k, v);
        }

        // Preserve per_page
        const perPage = currentParams.get('per_page');
        if (perPage) searchParams.set('per_page', perPage);

        // Preserve sort_by from the desktop select (which is outside the form)
        const sortSelect = document.querySelector('#SortBy');
        if (sortSelect && sortSelect.value) {
          searchParams.set('sort_by', sortSelect.value);
        }

        // Get and remove empty parameters
        searchParams.forEach((value, key) => { if (!value) emptyParams.push(key); });
        emptyParams.forEach((key) => searchParams.delete(key));

        this.applyFilters(searchParams.toString(), evt);
      }, timeoutDelay);
    }

    handleFiltersClick(evt) {
      const { target } = evt;

      // Filter 'clear' button clicked
      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        const clearUrl = new URL(evt.target.href);
        const clearParams = clearUrl.searchParams;

        // Preserve cf_* params
        const currentParams = new URLSearchParams(window.location.search);
        for (const [k, v] of currentParams.entries()) {
          if (k.startsWith('cf_') && v) clearParams.set(k, v);
        }

        // Preserve per_page
        const perPage = currentParams.get('per_page');
        if (perPage) clearParams.set('per_page', perPage);

        this.applyFilters(clearParams.toString(), evt);
      }

      // Filter 'show more' button clicked
      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        target.remove();

        filter.querySelectorAll('li').forEach((el) => {
          el.classList.remove('js-hidden');
        });

        if (!this.expanded.includes(filter.id)) {
          this.expanded.push(filter.id);
        }
      }
    }

    handleActiveFiltersClick(evt) {
      if (evt.target.tagName !== 'A') return;

      // Skip cf_* active filter tags — handled by custom-child-metafield-filters.js
      if (evt.target.hasAttribute('data-cf-tag')) return;

      evt.preventDefault();
      const isClearAll = evt.target.classList.contains('js-clear-all');
      const activeUrl = new URL(evt.target.href);
      const activeParams = activeUrl.searchParams;

      const currentParams = new URLSearchParams(window.location.search);

      // Only preserve cf_* params when removing individual native filters, NOT on "Clear all"
      if (!isClearAll) {
        for (const [k, v] of currentParams.entries()) {
          if (k.startsWith('cf_') && v) activeParams.set(k, v);
        }
      }

      // Preserve per_page
      const perPage = currentParams.get('per_page');
      if (perPage) activeParams.set('per_page', perPage);

      this.applyFilters(activeParams.toString(), evt);
    }

    handleHistoryChange(evt) {
      if (evt.state !== null) {
        let searchParams = '';
        if (evt.state && evt.state.searchParams) {
          ({ searchParams } = evt.state);
        }
        this.applyFilters(searchParams, null, false);
      }
    }

    async applyFilters(searchParams, evt, updateUrl = true) {
      try {
        const activeElementId = document.activeElement.id;

        // When product-specific filters are active, restrict type to 'product'
        // so Shopify doesn't paginate articles/pages that render as empty slots.
        const sp = new URLSearchParams(searchParams);
        let hasProductFilter = false;
        for (const key of sp.keys()) {
          if (key.startsWith('filter.p.') || key.startsWith('filter.v.')) {
            hasProductFilter = true;
            break;
          }
        }
        if (hasProductFilter && sp.get('type') && sp.get('type') !== 'product') {
          sp.set('type', 'product');
          searchParams = sp.toString();
        }

        // Set loading state
        if (this.results) this.results.classList.add('is-loading');

        const closeBtn = this.querySelector('.js-close-drawer-mob');
        if (closeBtn) {
          closeBtn.ariaDisabled = 'true';
          closeBtn.classList.add('is-loading');
        }

        // Build fetch URL with Section Rendering API
        let fetchUrl = `${window.location.pathname}?${searchParams}`;
        if (this.form.dataset.filterSectionId) {
          fetchUrl += `&section_id=${this.form.dataset.filterSectionId}`;
        }

        // Cancel previous fetch
        if (this.applyFiltersFetchAbortController) {
          this.applyFiltersFetchAbortController.abort('Request changed');
        }
        this.applyFiltersFetchAbortController = new AbortController();

        const response = await fetch(fetchUrl, {
          method: 'GET',
          signal: this.applyFiltersFetchAbortController.signal
        });

        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          // Restore UI state (which details were open)
          this.form.querySelectorAll('details.filter, details.disclosure').forEach((existingFilter) => {
            // Skip active-filters — its open state should reflect whether filters are active
            if (existingFilter.id === 'active-filters') return;
            const target = tmpl.content.getElementById(existingFilter.id);
            if (target) {
              target.open = existingFilter.open;
            }
          });

          // Force active-filters open when there are active filters
          const newActiveFilters = tmpl.content.getElementById('active-filters');
          if (newActiveFilters) {
            const hasActiveItems = newActiveFilters.querySelector('.active-filter');
            if (hasActiveItems) newActiveFilters.open = true;
          }

          // Restore expanded filters (show more was clicked)
          tmpl.content.querySelectorAll('#facets details.filter').forEach((newFilter) => {
            if (this.expanded.includes(newFilter.id)) {
              newFilter.querySelectorAll('.js-hidden').forEach((li) => li.classList.remove('js-hidden'));
              const moreBtn = newFilter.querySelector('.filter__more');
              if (moreBtn) moreBtn.remove();
            }
          });

          // Update the filters
          const newFacets = tmpl.content.getElementById('facets');
          if (newFacets) {
            this.form.innerHTML = newFacets.innerHTML;
          }

          // Update mobile close button label
          const newCloseBtn = tmpl.content.querySelector('.js-close-drawer-mob');
          if (closeBtn && newCloseBtn) {
            closeBtn.innerText = newCloseBtn.innerText;
          }

          // Update the results
          const newResults = tmpl.content.getElementById('filter-results');
          if (newResults && this.results) {
            this.results.innerHTML = newResults.innerHTML;
          }

          // Reinitialize re-rendered components
          this.addElements();
          this.addListeners();

          // Update the URL
          if (updateUrl) FacetFilters.updateURL(searchParams);

          // Scroll to the top of the results if needed
          if (this.results && this.results.getBoundingClientRect().top < 0) {
            let headerHeight = 0;
            const stickyHeader = document.querySelector('.site-header');
            if (stickyHeader) {
              headerHeight = stickyHeader.offsetHeight || 0;
            }
            window.scrollTo({
              top: this.results.getBoundingClientRect().top + window.scrollY - headerHeight - 45,
              behavior: 'smooth'
            });
          }

          // Enable the close button
          if (closeBtn) {
            closeBtn.classList.remove('is-loading');
            closeBtn.removeAttribute('aria-disabled');
          }

          // Focus on the element with the same ID in the new HTML
          if (activeElementId) document.getElementById(activeElementId)?.focus();

          // Fix counts/pagination (discontinued products inflate Shopify totals)
          if (typeof window.fixSearchCounts === 'function') {
            window.fixSearchCounts();
          }

          // Broadcast updates for other systems to hook into
          document.dispatchEvent(new CustomEvent('on:facet-filters:updated', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('collection:reloaded'));
        }
      } catch (error) {
        if (error !== 'Request changed') {
          console.warn(error);
        }
      } finally {
        if (this.results) this.results.classList.remove('is-loading');
      }
    }

    static updateURL(searchParams) {
      window.history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('facet-filters', FacetFilters);
}
